import { render, staticRenderFns } from "./TableBlock.vue?vue&type=template&id=156c6edb&scoped=true"
import script from "./TableBlock.vue?vue&type=script&lang=js"
export * from "./TableBlock.vue?vue&type=script&lang=js"
import style0 from "./TableBlock.vue?vue&type=style&index=0&id=156c6edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c6edb",
  null
  
)

export default component.exports